export const RESET_OS_SITUATION = 'OS_SITUATIONS/RESET_SITUATION';
export const SET_SUMMARY_OS_SITUATIONS = 'OS_SITUATIONS/SET_SUMMARY_OS_SITUATIONS';
export const SET_PAGINATION_OS_SITUATIONS = 'OS_SITUATIONS/SET_PAGINATION_OS_SITUATIONS';
export const SET_DETAILED_OS_SITUATION = 'OS_SITUATIONS/SET_DETAILED_OS_SITUATION';
export const SET_OS_SITUATIONS_WARNINGS = 'OS_SITUATIONS/SET_OS_SITUATIONS_WARNINGS';
